/* eslint-disable max-len */
import { ActiveAuthKey } from './constants';

export const activeAuthKeyRequest = (data) => ({ type: ActiveAuthKey.activeAuthKeyRequest, data });
export const activeAuthKeySuccess = (data) => ({ type: ActiveAuthKey.activeAuthKeySuccess, data });
export const activeAuthKeyError = () => ({ type: ActiveAuthKey.activeAuthKeyError });

export const getAccessUsersAuthKeySuccess = (data) => ({ type: ActiveAuthKey.getAccessUsersAuthKeySuccess, data });

export const getConnectedEndpointsToAuthKeysRequest = (data, callback) => ({ type: ActiveAuthKey.getConnectedEndpointsToAuthKeysRequest, data, callback });
export const getConnectedEndpointsToAuthKeysSuccess = (data) => ({ type: ActiveAuthKey.getConnectedEndpointsToAuthKeysSuccess, data });
